import { Typography } from '@altibox/lte-salgskanaler-design-system-component-lib';
import { styled } from 'styled-components';

import { Icon } from 'src/components/icons';
import { Picture } from 'src/components/picture';
import { colorMediumGrey, colorSecondary700 } from 'src/styles/colors';
import { changeIconStrokeColor, focus } from 'src/styles/mixins';
import { spacing2, spacing3 } from 'src/styles/spacing';

export const StyledContainer = styled.div`
  padding: ${spacing3} 0;

  &:not(:first-child) {
    border-top: 1px solid ${colorMediumGrey};
  }
`;

export const StyledContent = styled.div`
  flex: 1 1 0;
`;

export const StyledItemContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const StyledImage = styled(Picture)`
  margin-right: ${spacing2};
  max-width: 74px;
`;

export const StyledQuantityLabel = styled(Typography)`
  margin-right: ${spacing2};
`;

export const StyledButton = styled.button`
  background: transparent;
  border: 0;
  padding: 0;
  cursor: pointer;

  &:hover {
    ${changeIconStrokeColor(colorSecondary700)}
  }

  ${focus};
`;

export const StyledIcon = styled(Icon)`
  width: 24px;
  height: 24px;
`;
